export const METHOD_TAG = Symbol('method');
//# sourceMappingURL=component_params.js.map